angular.module('agreements')
    .controller('AgreementCategoryDialogController', function ($rootScope, $uibModalInstance, data, toastr, AgreementCategory, AgreementCategoryConst) {
        this.$onInit = () => {
            this.item = data
        }

        this.cancel = () => $uibModalInstance.dismiss()

        this.save = () => {
            let $promise
            if (this.item.id !== null) {
                $promise = AgreementCategory.update(this.item).$promise
            } else {
                $promise = AgreementCategory.save(this.item).$promise
            }
            return $promise
                .then(result => {
                    $rootScope.$broadcast(AgreementCategoryConst.eventUpdate)
                    $uibModalInstance.close(result)
                    toastr.success("Zapisano")
                })
        }
    })
